import React from 'react';
import styles from './index.module.less';
import Image from 'next/image';
import { cn } from '@/lib/utils';

const WhyDownloadStoriesContent = ({
  data,
}: {
  data?: {
    title?: string;
    cards?: {
      title?: string;
      desc?: string;
      imgPath?: string;
    }[];
  };
}) => {
  if (!data) return null;
  return (
    <section className={styles.content}>
      {data?.title && <h2 className={cn(styles.title, 'mb-[3.125rem]')}>{data?.title}</h2>}

      <div className={cn(styles.contentList, data?.cards?.length > 3 && styles.contentListMore)}>
        {data?.cards?.length > 0 &&
          data?.cards?.map((item, index) => (
            <div className={styles.contentItem} key={index}>
              <div className={cn(styles.contentItemTitle)}>
                <Image src={item.imgPath} alt={''} width={64} height={64} />
                <h3 className={styles.subTitle}>{item.title}</h3>
              </div>
              <p className={styles.subDesc}>{item.desc}</p>
            </div>
          ))}
      </div>
    </section>
  );
};

export default WhyDownloadStoriesContent;
